import React, { useState } from 'react';
import "../css/Forgot.css";
import Logo from "../assets/logonew.jpeg";
import { Link } from 'react-router-dom';

function Forgot() {
    const [email, setEmail] = useState('');
    const [userType, setUserType] = useState('admin');
    const [userCode, setUserCode] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        // Here you would typically handle the password reset request
        console.log({ userType, userCode, email });
        setIsSubmitted(true);
    };

    return (
        <div className="forgot-container">
            <div className="forgot-background"></div>
            <div className="forgot-card">
                <div className="forgot-left-panel">
                    <div className="forgot-logo">
                        <h2>SCHOOLPRO</h2>
                        <p>SOFTWARE</p>
                        <small>professional school management system</small>
                    </div>

                    <div className="forgot-info-panel">
                        <div className="forgot-info-icon">
                            <i className="fas fa-lock-open"></i>
                        </div>
                        <h3 className="forgot-info-title">Account Recovery</h3>
                        <p className="forgot-info-text">
                            We understand that access issues can happen. Please provide your registered 
                            details, and we'll help you regain access to your account.
                        </p>
                        <div className="forgot-steps">
                            <div className="forgot-step">
                                <span className="forgot-step-number">1</span>
                                <span className="forgot-step-text">Enter your user type and code</span>
                            </div>
                            <div className="forgot-step">
                                <span className="forgot-step-number">2</span>
                                <span className="forgot-step-text">Provide your registered email</span>
                            </div>
                            <div className="forgot-step">
                                <span className="forgot-step-number">3</span>
                                <span className="forgot-step-text">Check your inbox for instructions</span>
                            </div>
                        </div>
                    </div>

                    <div className="forgot-footer">
                        <p className="forgot-footer-text">Need help? Contact support</p>
                        <div className="forgot-social-links">
                            <a href="#" className="forgot-social-link"><i className="fab fa-facebook-f"></i></a>
                            <a href="#" className="forgot-social-link"><i className="fab fa-twitter"></i></a>
                            <a href="#" className="forgot-social-link"><i className="fab fa-linkedin-in"></i></a>
                            <a href="#" className="forgot-social-link"><i className="fab fa-youtube"></i></a>
                        </div>
                    </div>
                </div>
                <div className="forgot-right-panel">
                    <div className="forgot-school-logo">
                        <img src={Logo} alt="The UniUMS School" />
                        <h3>THE UniUMS SCHOOL</h3>
                    </div>
                    
                    {!isSubmitted ? (
                        <form className="forgot-form" onSubmit={handleSubmit}>
                            <h2 className="forgot-form-title">Password Recovery</h2>
                            <p className="forgot-form-subtitle">Enter your details to reset your password</p>
                            
                            <div className="forgot-user-type">
                                <label className={`forgot-type-option ${userType === 'admin' ? 'forgot-type-active' : ''}`}>
                                    <input
                                        type="radio"
                                        name="userType"
                                        value="admin"
                                        checked={userType === 'admin'}
                                        onChange={() => setUserType('admin')}
                                    />
                                    <span>Admin</span>
                                </label>
                                <label className={`forgot-type-option ${userType === 'teacher' ? 'forgot-type-active' : ''}`}>
                                    <input
                                        type="radio"
                                        name="userType"
                                        value="teacher"
                                        checked={userType === 'teacher'}
                                        onChange={() => setUserType('teacher')}
                                    />
                                    <span>Teacher</span>
                                </label>
                                <label className={`forgot-type-option ${userType === 'guardian' ? 'forgot-type-active' : ''}`}>
                                    <input
                                        type="radio"
                                        name="userType"
                                        value="guardian"
                                        checked={userType === 'guardian'}
                                        onChange={() => setUserType('guardian')}
                                    />
                                    <span>Guardian</span>
                                </label>
                            </div>
                            
                            <div className="forgot-input-group">
                                <label className="forgot-input-label">User Code</label>
                                <div className="forgot-input-wrapper">
                                    <i className="fas fa-user forgot-input-icon"></i>
                                    <input
                                        type="text"
                                        placeholder="Enter your user code"
                                        className="forgot-input"
                                        value={userCode}
                                        onChange={(e) => setUserCode(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>
                            
                            <div className="forgot-input-group">
                                <label className="forgot-input-label">Email Address</label>
                                <div className="forgot-input-wrapper">
                                    <i className="fas fa-envelope forgot-input-icon"></i>
                                    <input
                                        type="email"
                                        placeholder="Enter your email address"
                                        className="forgot-input"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>
                            
                            <div className="forgot-buttons">
                                <button type="submit" className="forgot-submit-button">
                                    <i className="fas fa-paper-plane"></i> Send Reset Link
                                </button>
                                <Link to="/" className="forgot-back-button">
                                    <i className="fas fa-arrow-left"></i> Back to Login
                                </Link>
                            </div>
                        </form>
                    ) : (
                        <div className="forgot-success">
                            <div className="forgot-success-icon">
                                <i className="fas fa-check-circle"></i>
                            </div>
                            <h2 className="forgot-success-title">Email Sent Successfully!</h2>
                            <p className="forgot-success-message">
                                We've sent password reset instructions to your email address. 
                                Please check your inbox and follow the instructions to reset your password.
                            </p>
                            <p className="forgot-success-note">
                                If you don't receive an email within 5 minutes, please check your spam folder.
                            </p>
                            <Link to="/" className="forgot-login-button">
                                <i className="fas fa-sign-in-alt"></i> Return to Login
                            </Link>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Forgot;